import React, { useCallback, useState } from 'react'
import {
    createColumnHelper,
    getCoreRowModel,
    useReactTable,
    getSortedRowModel
} from '@tanstack/react-table'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { Button, Dropdown, Form, InputGroup, Modal } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import ReactTable from '../../components/ReactTable'
import Pagination from '../../components/Pagination'
import requestApi from '../../utils/request'
import { formatDateToMonthShortwithFormate } from '../../functions/common'
import Swal from 'sweetalert2'
import { ReactComponent as Eyes } from '../../assets/images/teyes.svg'
import { ReactComponent as Edit } from '../../assets/images/tedit.svg'
import { ReactComponent as Delete } from '../../assets/images/tdelete.svg'
import { ReactComponent as DeleteImg } from '../../assets/images/redbin.svg'
import { ReactComponent as SearchIcon } from '../../assets/images/greysearch.svg'
import { ReactComponent as FilterIcon } from '../../assets/images/filter.svg'
import InputControl from '../../components/InputControl'
import DropDownControl from '../../components/DropDownControl'
import { addnewindustry, addnewstate, faqaddeditsubcategory } from '../../Routes/routingConsts'
import SpinnerLoader from '../../components/SpinnerLoader'
import Spinner from 'react-bootstrap/Spinner'
import { useEffect } from 'react'
import { deleteActionIcon, editactionIcon } from '../../functions/actionIcons'
import FlottedButton from '../../components/FlottingButton'

const FaqSubCategoryManagement = () => {
    const navigate = useNavigate()
    const [toggle, setToggle] = useState(null)
    const queryClient = useQueryClient()
    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [stateFilterText, setStateFilterText] = useState('')
    const [applicationStatus, setApplicationStatus] = useState('')
    const handleChange2 = (e) => {
        setCurrentPage(1)
        const getData = setTimeout(() => {
            setStateFilterText(e.target.value)
        }, 1000)
        clearInterval()
    }

    const handleChange = (eventkey) => {
        setDataLimit(eventkey)
    }
    const {
        register,
        handleSubmit,
        reset,
        getValues,
        control,
        formState: { errors }
    } = useForm()

    const [sorting, setSorting] = useState([])

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )
    // List Api call ///
    function stateDataList({ queryKey }) {
        return requestApi
            .post(
                `/faqSubCategory/list`,
                {
                    limit: queryKey[2],
                    page: queryKey[1],
                    search: queryKey[3],
                    sortKey: queryKey[4]?.id ?? '',
                    sortBy: queryKey[4] ? (queryKey[4]?.desc ? -1 : 1) : ''
                    // status:applicationStatus
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }
    const { data, isLoading } = useQuery({
        queryKey: [
            'state-list',
            currentPage,
            DataLimit,
            stateFilterText,
            sorting[0],
            applicationStatus
        ],
        queryFn: stateDataList
    })
    // End lisrt api ///
    let stateListCount = data?.meta?.totalCount

    // table column ////
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.display({
            id: 'actions',
            header: 'Action',
            cell: (row) => {
                return (
                    <>
                        <FlottedButton
                            clickFn={() => {
                                setToggle((pre) =>
                                    pre === row.row.original?.subCategoryId
                                        ? null
                                        : row.row.original?.subCategoryId
                                )
                            }}
                            isTrue={row.row.original?.subCategoryId === toggle}
                        >
                            {row?.row?.original?.status === 3 ? (
                                ''
                            ) : (
                                <li
                                    className="i1 icon"
                                    onClick={() =>
                                        handleEditIndustry(
                                            row?.row?.original?.subCategoryId
                                        )
                                    }
                                >
                                    {editactionIcon}
                                </li>
                            )}

                            {/* End Edit Country */}
                            {row?.row?.original?.status === 3 ? (
                                ''
                            ) : (
                                <li
                                    className="i1 icon"
                                    onClick={() =>
                                        hanleDeleteModal(
                                            row.row.original?.subCategoryId
                                        )
                                    }
                                >
                                    {deleteActionIcon}
                                </li>
                            )}
                        </FlottedButton>
                    </>
                )
            }
        }),
        columnHelper.accessor((row) => row.subCategoryName, {
            id: 'stateName',
            header: 'Sub-Category Name',
            cell: (row) => {
                return <p>{row?.row?.original?.subCategoryName}</p>
            }
        }),

        columnHelper.accessor((row) => row?.categoryName, {
            id: 'categoryName',
            header: 'category Name',
            cell: (row) => {
                return <p>{row?.row?.original?.categoryName}</p>
            }
        }),

        // columnHelper.accessor((row) => row.status, {
        //     id: 'status',
        //     header: 'Status',
        //     cell: (row) => {
        //         let flag = row.row.original.status
        //         return (
        //             <p
        //                 className={`labels ${
        //                     flag === 0 || flag === 1
        //                         ? 'active'
        //                         : flag === 3
        //                         ? 'deleted'
        //                         : ''
        //                 }`}
        //             >
        //                 {flag === 0 || flag === 1
        //                     ? 'Active'
        //                     : flag === 3
        //                     ? 'Deleted'
        //                     : ''}
        //             </p>
        //         )
        //     }
        // })
    ]

    // end table columns ////
    const tableInstance = useReactTable({
        data: data?.data,
        columns: columns,
        state: {
            sorting
        },
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })
    // edit industry///
    const handleEditIndustry = (id) => {
        navigate(`${faqaddeditsubcategory}/${id}`)
    }
    // end edit industry///

    // Delete Api call ////
    const [showDelete, setShowDelete] = useState(false)
    const [deletedId, setDeletedId] = useState(null)

    function deleteStateonId(subCategoryId) {
        return requestApi.post(`/faqSubCategory/delete`, { subCategoryId })
    }
    const mutationDelete = useMutation(deleteStateonId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('state-list')
            setShowDelete(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    const hanleDeleteModal = (subCategoryId) => {
        setShowDelete(true)
        setDeletedId(subCategoryId)
    }
    const handleDeleteUser = (subCategoryId) => {
        mutationDelete.mutate(subCategoryId)
        setShowDelete(false)
    }
    // End Delete Api call ///

    const handleOpening = () => {
        navigate(faqaddeditsubcategory)
    }

    // useEffect while record deleted on last page ////
    useEffect(() => {
        if (currentPage && data?.data?.length == 0) {
            setCurrentPage(1)
        } else {
        }
    }, [currentPage, data?.data])

    // End useEffect ////

    return (
        <>
            <div className="sidebar-content common-page">
                <div className="contentwhole-box details-box">
                    <div className="filter-titlebox">
                        <div className="title-text">
                            <h3>FAQ-Sub-Category Management</h3>
                        </div>
                        <div className="filterbox">
                            <div className="searcskills myaccount-page">
                                <div className="search-form">
                                    <div>
                                        <div className="searchstatus-box">
                                            <InputGroup className="mb-3 input-wrapper">
                                                <InputGroup.Text id="basic-addon1">
                                                    <SearchIcon />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    placeholder="Search"
                                                    type="search"
                                                    aria-label="Username"
                                                    aria-describedby="basic-addon1"
                                                    className="icontrol"
                                                    {...register(
                                                        'stateSearch',
                                                        {
                                                            onChange: (e) => {
                                                                handleChange2(e)
                                                            }
                                                        }
                                                    )}
                                                />
                                            </InputGroup>
                                            {/* <div className="status-dropdown">
                                            <Dropdown
                                                onSelect={
                                                     handleChangeApplicationStatus
                                                }
                                               
                                            >
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                >
                                                    {!!applicationStatus ? applicationStatus : "Application Status"}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                <Dropdown.Item eventKey="">
                                                        Application Status
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="Pending">
                                                        Pending
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="To interview">
                                                        To interview
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="Selected">
                                                        Selected
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="Rejected">
                                                        Not selected
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="Hold">
                                                        Hold
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div> */}

                                            {/* <div
                                            className="createnew"
                                            style={{
                                                pointerEvents: `${
                                                    isLoading
                                                        ? 'none'
                                                        : 'initial'
                                                }`
                                            }}
                                        >
                                            <button
                                                className="common-btn"
                                                onClick={handleOpening}
                                            >
                                                +Add State
                                            </button>
                                        </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="createnew"
                                    style={{
                                        pointerEvents: `${
                                            isLoading ? 'none' : 'initial'
                                        }`
                                    }}
                                >
                                    <button
                                        className="common-btn"
                                        onClick={handleOpening}
                                    >
                                        + Add Sub Category
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {isLoading ? (
                        <div className="spinner-wrapper">
                            <Spinner
                                animation="border"
                                role="status"
                                className="tdata"
                            >
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </Spinner>
                        </div>
                    ) : (
                        <>
                            {data?.data?.length > 0 ? (
                                <>
                                    <ReactTable tableInstance={tableInstance} />
                                    <div className="paginationbox">
                                        <div className="showingpages">
                                            <span>
                                                Showing{' '}
                                                {(currentPage - 1) * DataLimit +
                                                    1}{' '}
                                                to{' '}
                                                {Math.min(
                                                    currentPage * DataLimit,
                                                    stateListCount
                                                )}{' '}
                                                of {stateListCount} Sub-Categories
                                            </span>
                                        </div>
                                        {stateListCount > 10 && <div className="itemsperpage">
                                            <span>Items per page:</span>
                                            <Dropdown
                                                flip="no"
                                                onSelect={handleChange}
                                            >
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                >
                                                    {DataLimit}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item eventKey="10">
                                                        10
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="20">
                                                        20
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="30">
                                                        30
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>}
                                        {stateListCount > 10 && (
                                            <div className="pagination">
                                                <Pagination
                                                    total={Math.ceil(
                                                        stateListCount /
                                                            DataLimit
                                                    )}
                                                    current={currentPage}
                                                    onChangePage={
                                                        handleChangePage
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div className="noresult">
                                    <p>No Result Found</p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>

            {/* Delete modal */}
            <Modal
                className="modalbox deletemodal"
                show={showDelete}
                onHide={() => setShowDelete(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Form className="formbox">
                        <div className="delete-box">
                            <div className="deleteimg">
                                <DeleteImg />
                            </div>
                            <div className="content">
                                <h4>
                                    Are you sure you want to delete this <br />
                                    FAQ-Sub-Category?
                                </h4>
                            </div>
                            <div className="delete-action">
                                <button
                                    className="common-btn yes"
                                    type="button"
                                    onClick={() => handleDeleteUser(deletedId)}
                                >
                                    Yes
                                </button>
                                <button
                                    className="common-btn no"
                                    type="button"
                                    onClick={() => setShowDelete(false)}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default FaqSubCategoryManagement
